

export default () => ({
    visibleProducts: [],
    stockAndPricingData: [],
    startIndex: null,
    endIndex: null,
    totalProducts: null,
    loading: false,
    showDownloadLimitModal: false,
    pagination: {
        start: 1,
        stop: 1,
        page: 1,
        step: null,
        pages: 1,
        previousPages: [],
    },
    get numberOfResults() {
        return this.visibleProducts.length
    },
    load(category) {
        this.loading = true
        api
            .get('/category/products', {
                n: 20,
                p: this.page,
                id_category: category,
            })
            .then(({ data }) => {
                this.visibleProducts = data.products
                this.totalProducts = data.nb_products
                this.startIndex = (data.p - 1) * data.products_per_page + 1
                this.endIndex = data.p * data.products_per_page
                this.loading = false
                this.pagination.start = data.start
                this.pagination.stop = data.stop
                this.pagination.page = data.p
                this.pagination.step = data.step
                this.pagination.pages = data.pages_nb
                this.pagination.previousPages = Array.from(
                    Array(data.stop + 1 - data.start),
                    (_, x) => x + data.start,
                )
                this.fetchStockAndPricing()
            })
    },
    stockAndPricing(productId) {
        return this.stockAndPricingData.find((e) => e.id_product === productId)
    },
    fetchStockAndPricing() {
        const productIds = this.products.map((product) => product.objectID)
        const currency = window.Alpine.store('currency').id
        const url = `${window.accuvars.api_url}/stock-and-price`
        api
            .get(url, {
                currency,
                products: productIds.join(','),
            })
            .then(({ data }) => {
                this.stockAndPricingData = data
                const newProducts = this.products.map((product) => ({
                    ...product,
                    stock_and_pricing: data.find(
                        (e) => e.id_product === product.objectID,
                    ),
                }))
                this.products = newProducts
            })
    },
})
